import { odata } from '../../conf';
import Actions from '../../odata/actionsForStringId';

const actions = new Actions('brand', 'brands', 'code');

const customActions = {
  async LOAD_suppliers({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('brands')
      .query({ $filter: 'IsDeleted eq false', $orderby: 'Name' });
    commit('SET_brands', data);

    return data;
  },
};

export default { ...actions, ...customActions };
